import * as Sentry from '@sentry/browser'
import { API_BASE_URL, X_API_KEY } from './api'

export const AllUserFull = async (userId: string, token: string) => {
  try {
    const response = await fetch(`${API_BASE_URL}/user/${userId}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    })
    const data = await response.json()

    if (!response.ok) {
      throw new Error(data.error || 'Failed to fetch user status')
    }

    return data
  } catch (error) {
    Sentry.captureException(error, {
      extra: {
        action: 'fetchUserStatus',
        userId,
        timestamp: new Date().toISOString(),
      },
      tags: {
        type: 'api_error',
        method: 'fetchUserStatus',
      },
    })
    throw error
  }
}

export const getUser = async (userId: string, token: string) => {
  try {
    const response = await fetch(`${API_BASE_URL}/user/${userId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'x-api-key': X_API_KEY,
      },
    })

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.error || 'Failed to fetch user')
    }

    return response.json()
  } catch (error) {
    Sentry.captureException(error, {
      extra: {
        action: 'getUser',
        userId,
        timestamp: new Date().toISOString(),
      },
      tags: {
        type: 'api_error',
        method: 'getUser',
      },
    })
    throw error
  }
}

export const updateUser = async (
  userId: string,
  token: string,
  userData: any,
) => {
  try {
    const preparedData = {
      ...userData,
    }

    const response = await fetch(`${API_BASE_URL}/user/${userId}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'x-api-key': X_API_KEY,
      },
      body: JSON.stringify(preparedData),
    })

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.error || 'Failed to update user')
    }

    return response.json()
  } catch (error) {
    Sentry.captureException(error, {
      extra: {
        action: 'updateUser',
        userId,
        userData,
        timestamp: new Date().toISOString(),
      },
      tags: {
        type: 'api_error',
        method: 'updateUser',
      },
    })
    throw error
  }
}
